import "./Authorization.scss";
import React from "react";
import { IonAlert } from "@ionic/react";
import { useTracked } from "../../state";
import { Plugins } from "@capacitor/core";
import { usePlatform } from "../../utils/hooks";
import { updateRequestHistory } from "../../api/requestHistory";
import { v4 } from "uuid";
import { verifyLogin } from "../../api/chain";
import { ShowToastErrorMessage } from "../../utils/helpers/ToastMessage";

const { App } = Plugins;

interface Props {
  authorization?: any;
  setAuthrization?: any;
}

const Authorization: React.FC<Props> = ({ authorization, setAuthrization }) => {
  const [state, dispatch] = useTracked();
  const platform = usePlatform();
  const [header, setHeader] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [identity, setIdentity] = React.useState("");
  const [token, setToken] = React.useState("");
  const [appId, setAppId] = React.useState<any>("");
  const [isOpen, setIsOpen] = React.useState(false);
  const [props, setProps] = React.useState({});
  const [reqId, setReqId] = React.useState<any>("");
  const [authRequestId, setAuthRequestId] = React.useState<any>("");

  React.useEffect(() => {
    if (state.authorization && state.identity && state.token) {
      const {
        header,
        message,
        identity,
        token,
        appId,
        isOpen,
        requestId,
        authRequestId,
        ...props
      } = state.authorization;

      const isAppLocked = localStorage.getItem("isAppLocked");
      if (isAppLocked && state.hasSession) {
        setIsOpen(false);
        return;
      }

      if (state.identity.toLowerCase() === identity.toLowerCase()) {
        setHeader(header);
        setMessage(message);
        setIdentity(identity);
        setToken(token);
        setAppId(appId);
        setIsOpen(isOpen);
        setReqId(requestId);
        setAuthRequestId(authRequestId);
        setProps({ ...props });
      }
    } else {
      if (!state.identity) {
        setIsOpen(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.authorization, state.identity, state.token]);

  React.useEffect(() => {
    if (authorization && state.identity && state.token) {
      const {
        header,
        message,
        identity,
        token,
        appId,
        isOpen,
        requestId,
        authRequestId,
        ...props
      } = authorization;

      const isAppLocked = localStorage.getItem("isAppLocked");
      if (isAppLocked && state.hasSession) {
        setIsOpen(false);
        return;
      }

      if (state.identity.toLowerCase() === identity.toLowerCase()) {
        setHeader(header);
        setMessage(message);
        setIdentity(identity);
        setToken(token);
        setAppId(appId);
        setIsOpen(true);
        setReqId(requestId);
        setAuthRequestId(authRequestId);
        setProps({ ...props });
      }
    } else {
      if (!state.identity) {
        setIsOpen(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorization, state.identity, state.token]);

  const onDidDismissHandler = () => {
    try {
      setIsOpen(false);
    } catch (e) {}
  };

  const onApprove = async () => {
    try {
      if (reqId) {
        const response: any = await verifyLogin({
          appId,
          token,
          authRequestId,
          requestId: reqId,
        });

        if (response?.status === 200) {
          dispatch({
            type: "setAuthorizationActionTimestamp",
            authorizationActionTimestamp: v4(),
          });
          setReqId("");
        } else {
          ShowToastErrorMessage(
            response?.message ? response.message : "Unable to allow request."
          );
        }
      }

      //NOTE: might be removed
      if (appId === 2) {
        // abaxx messenger
        launchApp();
      }
    } catch (e: any) {
      ShowToastErrorMessage(
        e?.message ? e.message : "Unable to allow request."
      );
    }
  };

  const onDeny = async () => {
    if (state.mqm) {
      await state.mqm.pubnub.publish({
        channel: identity,
        meta: {
          type: "authorizationDeny",
        },
        message: { identity, token, appId, authRequestId },
      });
    }

    if (reqId) {
      // update request history if it has request ID
      updateRequestHistory(reqId, {
        status: "DENIED",
      }).then((response: any) => {
        dispatch({
          type: "setAuthorizationActionTimestamp",
          authorizationActionTimestamp: v4(),
        });
      });
      setReqId("");
    }
  };

  const launchApp = async () => {
    try {
      if (platform === "ios" || platform === "android") {
        let url = process.env.REACT_APP_MESSENGER_URL || "https://app.abaxx.id";

        const canOpen = await App.canOpenUrl({ url });

        if (canOpen && canOpen.value) {
          await App.openUrl({ url });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <React.Fragment>
      {isOpen && (
        <IonAlert
          {...props}
          header={header}
          message={message}
          // subHeader={'subHeader'}
          isOpen={isOpen}
          cssClass={""}
          onDidDismiss={onDidDismissHandler}
          backdropDismiss={false}
          buttons={[
            {
              text: "Deny",
              role: "cancel",
              cssClass: "secondary",
              handler: () => {
                onDeny();
                setAuthrization(null);
                setIsOpen(false);
                // dispatch({ type: 'setPendingPush', pendingPush: '' });
              },
            },
            {
              text: "Allow",
              handler: () => {
                onApprove();
                setAuthrization(null);
                setIsOpen(false);
                // dispatch({ type: 'setPendingPush', pendingPush: '' });
              },
            },
          ]}
        />
      )}
    </React.Fragment>
  );
};

export default Authorization;
